import i18n from 'i18n/config';
import { useEffect, useState } from 'react';
import { UsufructData } from 'types';

type Props = {
  usufructData: UsufructData[];
};

const getTooltipText = (usufructData: UsufructData[]): string => {
  if (!usufructData || !usufructData.length) return '';

  const lines = usufructData.map((data: UsufructData) => {
    const name = data.partnerName || '';
    const sharesCount = data.sharesCount || 0;
    const percentage = data.percentage || 0;
    const { isMainCoOwner } = data;

    const translationKey = isMainCoOwner
      ? 'MainUsufructuaryTooltip'
      : 'UsufructuaryTooltip';

    return `• ${i18n.t(translationKey, { name, sharesCount, percentage })}`;
  });

  return lines.join('\n');
};

export const useGetUsufructuariesTooltipText = ({ usufructData }: Props) => {
  const [tooltipText, setTooltipText] = useState<string>('');

  useEffect(() => {
    const text = getTooltipText(usufructData);
    setTooltipText(text);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usufructData, i18n.language]);

  return {
    data: { tooltipText },
  };
};
